export const GET_LOCATIONS_API_REQUEST = 'GET_LOCATIONS_API_REQUEST';
export const GET_LOCATIONS_API_SUCCESS = 'GET_LOCATIONS_API_SUCCESS';
export const GET_LOCATIONS_API_ERROR = 'GET_LOCATIONS_API_ERROR';
export const GET_FILTERED_LOCATIONS_API_REQUEST = 'GET_FILTERED_LOCATIONS_API_REQUEST';
export const GET_FILTERED_LOCATIONS_API_SUCCESS = 'GET_FILTERED_LOCATIONS_API_SUCCESS';
export const GET_FILTERED_LOCATIONS_API_ERROR = 'GET_FILTERED_LOCATIONS_API_ERROR';
